import React from 'react'
import styled from 'styled-components'
import Skeleton from '@material-ui/lab/Skeleton'

const readOnly = process.env.REACT_APP_READ_ONLY

const FilterSection = styled.div`
  box-sizing: border-box;
  height: 132px;
  padding: 24px 32px 0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
`

// same structure as Grid container spacing={2} with items at 25% / min 256px
const FilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -8px;
`

const FilterItem = styled.div`
  box-sizing: border-box;
  width: 25%;
  min-width: 256px;
  padding: 8px;
  margin-bottom: 8px;
`

const FilterFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 42px;
  margin-top: 8px;
`

const ProposalsSection = styled.div`
  padding: 32px;
`

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 50px;
  margin-bottom: 8px;
`

const Controls = styled.div`
  display: flex;
  align-items: center;
`

// Mirrors the real card grid in ProposalCards (default zoom level 3) and the
// MdProposal card: thumbnail with 1.414 aspect ratio plus a footer row.
const CARD_COUNT = 105

const CardsGrid = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  margin-top: 25px;
`

const Card = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);

  > :first-child {
    aspect-ratio: 1.414 / 1;
    height: auto !important;
  }
`

const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 2.8rem;
  padding: 0.25rem 0.5rem;
`

export default function LoadingProposals() {
  return (
    <div>
      <FilterSection>
        <FilterRow>
          {Array.from(new Array(readOnly ? 1 : 4)).map((element, index) => (
            <FilterItem key={index}>
              <Skeleton variant="rect" width="100%" height={35} />
            </FilterItem>
          ))}
        </FilterRow>

        <FilterFooter>
          <Skeleton variant="text" width={250} height={24} />
          <Skeleton variant="text" width={300} height={24} />
        </FilterFooter>
      </FilterSection>

      <ProposalsSection>
        <HeaderRow>
          <Skeleton variant="rect" width={146} height={32} />

          <Controls>
            <Skeleton
              variant="rect"
              width={143}
              height={35}
              style={{ margin: '0 8px' }}
            />
            <Skeleton variant="text" width={47} style={{ marginRight: 4 }} />
            <Skeleton
              variant="rect"
              width={200}
              height={33}
              style={{ marginRight: 10 }}
            />
            <Skeleton variant="rect" width={77} height={35} />
          </Controls>
        </HeaderRow>

        <CardsGrid>
          {Array.from(new Array(CARD_COUNT)).map((element, index) => (
            <Card key={index}>
              <Skeleton variant="rect" width="100%" height="100%" />
              <CardFooter>
                <Skeleton variant="text" width="2rem" height="100%" />
                <Skeleton variant="text" width="6rem" height="100%" />
              </CardFooter>
            </Card>
          ))}
        </CardsGrid>
      </ProposalsSection>
    </div>
  )
}
